import Switch from "@mui/material/Switch"
import { alpha, styled } from "@mui/material/styles"
import { WW_BLUE } from "@/theme/tokens"

// Shared colourable switch base (previously duplicated per panel).
export const ColoredSwitch = styled(Switch)(({ theme, color }) => ({
  "& .MuiSwitch-switchBase": {
    color: "#ffffff",
    "&:hover": {
      backgroundColor: alpha(color, theme.palette.action.hoverOpacity),
    },
  },
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: color,
    "&:hover": {
      backgroundColor: alpha(color, theme.palette.action.hoverOpacity),
    },
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: color,
  },
}))

// The app-standard dark-blue toggle used across the panels.
export default function BlueSwitch(props) {
  return <ColoredSwitch {...props} color={WW_BLUE} />
}
